module.exports = __webpack_public_path__ + "static/img/9-g.b3944cb0.png";